import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "breadcrumbs",
    templateUrl: "./breadcrumbs.component.html",
    standalone: false
})

export class BreadcrumbsComponent implements OnInit{
    breadcrumbList: Array<Object> | null = null;
    formObj: any;

    @Input() curTab: string;

    constructor() {
    }

    ngOnInit() {
    }
}